import { z } from 'zod'

export enum Language {
  KO = 'ko',
  EN = 'en',
  JA = 'ja',
  ZH = 'zh',
}

export const ZLanguage = z.nativeEnum(Language)

export type TLanguage = z.infer<typeof ZLanguage>
